import { FC, useEffect, useState } from 'react';
import CustomerAddCOFContent from 'containers/customers/components/CustomerAddCOFContent';
import { AddressField } from 'containers/invoices/invoices.model';
import { Loader } from 'components';
import { useAppSelector } from 'hooks';
import { selectWebViewParams } from 'containers/auth/authSlice';
import { WebviewFunctions } from 'constants/common';
import { ANALYTICS_EVENT_NAMES, ANALYTICS_EVENT_TYPES } from 'constants/webview';

const CustomerAddCOFWebViewPage: FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const webViewParams = useAppSelector(selectWebViewParams);

  // Extract parameters from webview params stored in Redux
  const { teamId, customerId, customerData } = webViewParams;

  // Parse customer data from JSON string provided by mobile app
  let customerName: string | undefined;
  let customerEmail: string | undefined;
  let customerBillingAddress: AddressField | undefined;
  let cardId: string | undefined;
  if (customerData) {
    try {
      const parsedCustomerData = JSON.parse(decodeURIComponent(customerData));
      customerName = parsedCustomerData?.customerName;
      customerEmail = parsedCustomerData?.customerEmail;
      customerBillingAddress = parsedCustomerData?.billingAddress;
      cardId = parsedCustomerData?.cardId;
    } catch (error) {
      // If parsing fails, use undefined values
      customerName = undefined;
      customerEmail = undefined;
      customerBillingAddress = undefined;
      cardId = undefined;
    }
  }

  useEffect(() => {
    // Simulate loading time to ensure smooth webview experience
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    // Handle webview close for mobile app
    if (window?.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler(WebviewFunctions.TRACK_ANALYTICS_EVENT, {
        eventName: ANALYTICS_EVENT_NAMES.ADD_CARD_ON_FILE_WEBVIEW,
        properties: {
          type: ANALYTICS_EVENT_TYPES.WEBVIEW_CLOSED
        }
      });
      window.flutter_inappwebview.callHandler(WebviewFunctions.CLOSE_WEBVIEW_CHECKOUT);
    }
  };

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-white">
        <Loader />
      </div>
    );
  }

  return (
    <CustomerAddCOFContent
      handleClose={handleClose}
      isWebView={true}
      customerId={customerId}
      teamId={teamId}
      customerName={customerName}
      customerEmail={customerEmail}
      customerBillingAddress={customerBillingAddress}
      cardId={cardId}
      successCallback={handleClose}
    />
  );
};

export default CustomerAddCOFWebViewPage;
